import './styles.scss'
import Label from "components/Label";

import Button from 'components/common/Buttons';

const SingleBody = ({ label, title, desc, button = null, link = null }) => {
    return (
        <>
            <div className="single-body">
                <Label text={label} />
                <h2>{title}</h2>

                <div className="body2">{desc}</div>

            </div>
            {
                button && <Button text={button} to={link} />
            }
        </>
    );
}

export default SingleBody;